import { SearchOutlined } from '@ant-design/icons';
import { Col, DatePicker, Form, FormInstance, Select } from 'antd';
import { AxiosError } from 'axios';
import { useCallback, useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import GetProducers from '~/@core/application/useCases/rfidReports/inventory/getProducers';
import GetDones from '~/@core/application/useCases/rfidReports/movement/getDones';
import DefaultPaginated from '~/@core/domain/@shared/DefaultPaginated';
import Movement from '~/@core/domain/model/rfidReports/Movement';
import Producer from '~/@core/domain/model/rfidReports/Producer';
import FormFilterDataModel, {
  MapFormToFilter
} from '~/@core/domain/ui/forms/FormFilterDataModel';
import DefaultRow from '~/components/bosons/DefaultRow';
import SearchButton from '~/components/Buttons/SearchButton';
import { globalContext } from '~/context/GlobalContext';
import useProducerStore from '~/zustand/rfidReports/inventory/producer-state';
import useDoneStore from '~/zustand/rfidReports/movement/done-state';
import { SearchButtonDiv } from '../../Inventory/Dones/FormFilterInventoryDone.styled';
import { PermissionNames } from '~/constants/permissionNames';

const { Option } = Select;

interface Props {
  form: FormInstance<FormFilterDataModel>;
}
export default function FormFilterMovementDones(props: Props) {
  const { form } = props;
  const { t } = useTranslation();
  const { donePagination, addDones, handleDonePagination, setIsLoadingDone } =
    useDoneStore();

  const { handlePromiseUseCase, activeAlert } = useContext(globalContext);

  useEffect(() => {
    form.setFieldsValue({
      dtaFilter: []
    });
  }, [form]);

  const { producers, addProducers } = useProducerStore();

  useEffect(() => {
    const permissionName = PermissionNames.RfidReports.MenuMovement;
    const getProducers = new GetProducers(permissionName);
    setIsLoadingDone();

    handlePromiseUseCase<Producer[], AxiosError>(
      getProducers.execute(),
      producerOut => {
        addProducers(producerOut);
        setIsLoadingDone();
      },
      error => {
        activeAlert({
          message: JSON.stringify(
            error.response?.data
              ? error.response?.data
              : 'Houve um erro inesperado!'
          ),
          type: 'error',
          timeout: 5000
        });
        setIsLoadingDone();
      }
    );
  }, []);

  const onSubmitFilter = useCallback(
    (formValues: FormFilterDataModel) => {
      const filterDone = MapFormToFilter.toFilter(formValues, {
        pageSize: donePagination.pageSize,
        pageNumber: donePagination.current
      });

      const getDones = new GetDones();

      handlePromiseUseCase<DefaultPaginated<Movement[]>, AxiosError>(
        getDones.execute(filterDone),
        ralizadosOut => {
          addDones(ralizadosOut.results);
          handleDonePagination({
            ...donePagination,
            total: ralizadosOut.totalCount
          });
        },
        error => {
          activeAlert({
            message: JSON.stringify(
              error.response?.data
                ? error.response?.data
                : 'Houve um erro inesperado!'
            ),
            type: 'error',
            timeout: 5000
          });
        }
      );
    },
    [
      activeAlert,
      addDones,
      handleDonePagination,
      handlePromiseUseCase,
      donePagination
    ]
  );

  return (
    <Form layout="vertical" form={form} onFinish={onSubmitFilter}>
      <DefaultRow>
        <Col lg={6}>
          <Form.Item name="dtaFilter" label="Data de Consulta: ">
            <DatePicker.RangePicker
              format="DD/MM/YYYY"
              placeholder={['Início', 'Fim']}
            />
          </Form.Item>
        </Col>
        <Col lg={6}>
          <Form.Item
            name="producerFilter"
            label="Sitio: "
            rules={[{ required: true }]}
          >
            <Select allowClear placeholder="Selecione">
              {producers.map(producer => (
                <Option value={producer.account}>
                  {producer.account} - {producer.tradingName}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col lg={3}>
          <SearchButtonDiv>
            <SearchButton
              htmlType="submit"
              type="primary"
              icon={<SearchOutlined />}
              onClick={() => {}}
            />
          </SearchButtonDiv>
        </Col>
      </DefaultRow>
    </Form>
  );
}
